export default __webpack_public_path__ + "static/media/1990.38d8c4bc.png";